/* eslint-disable react/prefer-stateless-function */
// TODO Make SubBar a pure component
import React from 'react'
import BreadcrumbRoute from './breadcrumb-route'

class SubBar extends React.Component {
  render() {
    return (
      <div className="acc-content-subbar">
        <BreadcrumbRoute />
      </div>
    )
  }
}
export default SubBar
